import { render, staticRenderFns } from "./userStatusTemp.vue?vue&type=template&id=32224b59&"
import script from "./userStatusTemp.vue?vue&type=script&lang=js&"
export * from "./userStatusTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports